module.exports = __webpack_public_path__ + "img/store-speed-61_100.4c2f6190.svg";